import { Title } from '@repo/foundations';
import { NavBarBreadcrumbWrapper, NavBarWrapper } from '.';

function SearchPageNavBar() {
	return (
		<NavBarWrapper>
			<NavBarBreadcrumbWrapper>
				<Title order={1} size="sm" data-testid="search-page-nav-bar-title">
					Search
				</Title>
			</NavBarBreadcrumbWrapper>
		</NavBarWrapper>
	);
}

export default SearchPageNavBar;
